// Routes that Ask may present as direct navigation actions. Keep this list
// smaller than the router. Project detail pages can remain valid citation
// destinations without being described as top-level places to browse.

export const AI_NAVIGATION_PATHS = Object.freeze([
  '/about',
  '/projects',
  '/research',
  '/research/ai-writing-interview',
  '/fragments',
  '/experience',
  '/education',
  '/travels',
  '/early',
  '/playbook',
  '/lexaday',
  '/dealtracker',
  '/stride',
  '/scrollytelling',
  '/ragflow-pipeline',
  '/ai-it-operations',
  '/views',
  '/cv',
]);

const AI_NAVIGATION_SET = new Set(AI_NAVIGATION_PATHS);

export function isAiNavigationPath(path) {
  const value = String(path || '').trim();
  const base = value.split(/[?#]/, 1)[0] || '';
  return AI_NAVIGATION_SET.has(base);
}

export function aiNavigationPromptList() {
  return AI_NAVIGATION_PATHS.join(', ');
}
